export default __webpack_public_path__ + "4af4069cc32b7436f2d76cccfe9a9e11.avif";